<template>
  <div class="settings-dashboard-cards">
    <b-list-group>
      <b-list-group-item v-for="(card, i) in cards" :key="card.id" class="d-flex flex-row align-items-middle">
        <div class="flex-fill cursor-pointer">
          <p class="lead m-0" @click="() => selectedIndex = i">{{ card.title }}</p>
          <b-badge v-if="card.locale" class="my-1" variant="light">{{ userLocaleEnums[card.locale] }}</b-badge>
          <div class="d-flex flex-row flex-wrap" v-if="Array.isArray(card.segments) && card.segments.length">
            <b-badge v-for="({ id, title }) in card.segments" :key="id" class="my-1 mr-2" variant="primary">{{ title }}</b-badge>
          </div>
        </div>
        <div>
          <b-btn @click="() => selectedIndex = i" size="sm"><font-awesome-icon icon="pencil-alt"/></b-btn>
        </div>&nbsp;
        <div>
          <b-btn @click="() => deleteItem(i)" size="sm" variant="danger"><font-awesome-icon icon="trash"/></b-btn>
        </div>
      </b-list-group-item>
      <b-list-group-item class="d-flex justify-content-end">
        <b-btn @click="() => selectedIndex = -1" size="sm" variant="primary">
          <font-awesome-icon icon="plus"/>
        </b-btn>
      </b-list-group-item>
    </b-list-group>
    <b-modal v-if="selectedIndex !== null" visible hide-footer @hide="() => selectedIndex = null"
      :title="selectedIndex === -1 ? 'New Dashboard Card' : 'Edit Dashboard Card'">
      <advanced-form layout="inline-md-3" :form="form" :submit-label="selectedIndex === -1 ? 'Create' : 'Update'"
        :value="values[selectedIndex] || null" @submit="value => writeItem(selectedIndex, value)"/>
    </b-modal>
  </div>
</template>

<script>
import AdvancedForm from '@src/components/AdvancedForm';
import enumsMixin from '@src/mixins/enums';
import { flatten, unflatten } from 'flat';
import { mapRoot } from '@src/mixins/root';
import { ulid, monotonicFactory } from 'ulid';

export default {
  props: {
    cards: {
      type: Array,
      default: () => ([]),
    },
    segments: {
      type: Array,
      default: () => ([]),
    },
  },
  mixins: [
    enumsMixin,
  ],
  components: {
    AdvancedForm,
  },
  data() {
    const createUlid = monotonicFactory();
    return {
      selectedIndex: null,
      values: (Array.isArray(this.cards) ? this.cards : []).map(({ segments, ...card }) => {
        delete card.__typename;
        card = flatten(card);
        card.id = createUlid();
        card.segments = Array.isArray(segments) ? segments.map(({ id }) => id) : null;
        return card;
      }),
    };
  },
  computed: {
    ...mapRoot([ 'supportedLanguages' ]),
    columns() {
      const { supportedLanguages } = this;
      return [
        { key: 'title' },
        ...(Array.isArray(supportedLanguages) && supportedLanguages.length
          ? [ { key: 'locale', formatter: value => typeof value === 'string' ? value.toUpperCase() : value } ]
          : []),
        { key: 'segments', formatter: value => Array.isArray(value) ? value.length : 'All' },
        { key: '_opts', label: '' },
      ];
    },
    form() {
      return {
        title: {
          label: 'Title',
          type: 'STRING',
        },
        body: {
          label: 'Body',
          type: 'HTML',
          options: {
            extensions: [ 'strong', 'italic', 'strike', 'link', 'ul', 'ol' ]
          },
        },
        'cta.text': {
          label: 'Button Text',
          type: 'STRING',
        },
        'cta.url': {
          label: 'Button URL',
          type: 'STRING',
        },
        ...(Array.isArray(this.supportedLanguages) && this.supportedLanguages.length ? {
          locale: {
            label: 'Locales',
            type: 'SELECT',
            placeholder: 'All locales',
            choices: this.userLocaleEnums,
          },
        } : {}),
        ...(this.segments.length ? {
          segments: {
            label: 'Segments',
            type: 'CHECKBOX_GROUP',
            choices: this.segments.reduce((list, { id, title }) => ({ ...list, [id]: title }), {}),
          },
        } : {}),
      };
    },
  },
  methods: {
    writeItem(i, card) {
      if (i >= 0) {
        this.values[i] = card;
      } else {
        this.values.push({ id: ulid(), ...card });
      }

      this.selectedIndex = null;
      submit.call(this, this.values);
    },
    deleteItem(i) {
      this.values.splice(i, 1);
      submit.call(this, this.values);
    },
  },
};

function submit(cards) {
  this.$emit('submit', cards.map(({ segments, ...card }) => {
    delete card.id;
    delete card.cta;
    card = unflatten(card);
    card.segments = Array.isArray(segments) && segments.length
      ? { id_in: segments.map(id => id) }
      : null;
    return card;
  }));
}
</script>



// WEBPACK FOOTER //
// src/components/settings/DashboardCards.vue